import { FC, ReactNode, useEffect, useMemo, useRef } from "react";

export function useMounted() {
	const mounted = useRef(false);

	useEffect(function Mount() {
		mounted.current = true;

		return function Unmount() {
			mounted.current = false;
		}
	}, []);

	return mounted;
}

export function useAsyncEffect(execute : (abort: AbortSignal) => void | Promise<void>, dep ?: unknown[]) {
  return useEffect(function AsyncEvent() {
    let aborter = new AbortController();
    execute(aborter.signal);

    return () => {
      aborter.abort("Async Effect dependencies changed");
    };
  }, dep);
}

export const RichFormat: FC<{
	format: string,
	arg: ReactNode,
}> = (props) => {
	return useMemo(() => {
		let split  = props.format.indexOf("{0}");
		let before = props.format.slice(0, split);
		let after  = props.format.slice(split+3);

		return <>
			{before}
			{props.arg}
			{after}
		</>
	}, [props.format, props.arg]);
}

